import React from 'react';
import { useParams } from 'react-router-dom';
import EventRevenueEntryPanel from '@/components/event/EventRevenueEntryPanel';
export default function EventRevenueEntryPage() {
  const { id, eventId } = useParams(), value = id ?? eventId;
  if (!/^[1-9][0-9]*$/.test(String(value||''))) return <p role="alert" className="p-6 text-rose-300">Invalid event id.</p>;
  return <main className="mx-auto max-w-5xl p-4"><EventRevenueEntryPanel eventId={Number(value)} /></main>;
}
